import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Bs4Kartoteka from '../Bs4Kartoteka'
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Bs4Draggable from './Bs4Draggable'
import { mouseOverSnackbar } from '../Bs4Snackbar'

export default function Bs4Modal (props) {
  const [disableDrag, setDisableDrag] = React.useState(false);
  const [style, setStyle] = React.useState(() => {
    const style = {};
    if (props.width) style.width = props.width; else style.maxWidth = '70%';
    if (props.height) style.height = props.height; else style.maxHeight = '70%';    
    return style;
  });
  const theme = useTheme()  
  const [visibility, setVisibility] = React.useState(props.bs4Kartoteka?.visibility)
  const refModal = React.useRef();

  const setRef = (el) => {
    if (el && (!style.width || !style.height)) {
      setStyle({
        width:el?.offsetWidth,
        height:el?.offsetHeight
      })          
    }  
    refModal.current=el;
  }

  const handleClickAway = (event) => {
    if (mouseOverSnackbar) return;
    const rect = refModal.current.getBoundingClientRect();
    if (event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom) return;    
    if (props.isTop && props.open && visibility && props?.onClose) props.onClose(event, '')
  }

  React.useEffect(() => {
    props.bs4Kartoteka?.on(Bs4Kartoteka.CHANGE_VISIBILITY, setVisibility);
    return () => props.bs4Kartoteka?.off(setVisibility);
  }, [props.bs4Kartoteka, setVisibility])

  /// zbadać /// <Modal open={props.open && visibility} keepMounted >
  return (        
    <Modal 
      open={props.open} sx={{visibility: visibility ? Bs4Kartoteka.VISIBILITY_VISIBLE : Bs4Kartoteka.VISIBILITY_HIDDEN}} 
      // disableEnforceFocus 2023-05-05 1153 Edytor HTML w oknie popup [Core]
      // Do obserwacji - nie zalecane 
      // Mui : 	
      // If true, the modal will not prevent focus from leaving the modal while open.
      // Generally this should never be set to true as it makes the modal less accessible to assistive technologies, like screen readers.
      disableEnforceFocus
    > 
      <Box 
        width='100%' 
        height='100%' 
        display='flex' 
        flexDirection='column' 
        justifyContent='center' 
        alignItems='center'        
      >
        <Bs4Draggable id='Bs4Modal_Draggable' refElement={refModal} refHeader={props.refHeader}>
          <ClickAwayListener onClickAway={handleClickAway}>
            <Box
              ref={setRef}
              display='flex'
              overflow='hidden'
              borderRadius={theme.shape.borderRadius+'px'}
              boxShadow={theme.shadows[24]}
              sx={{minWidth: 3, minHeight: 3, resize:'both', overflow:'auto', p: 1, ...style, backgroundColor: theme.Bs4.backgroundColor}}              
            >
              {props.children}
            </Box>
          </ClickAwayListener>
        </Bs4Draggable>
      </Box>
    </Modal>       
  );
}